import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import Flex from '../Flex';

const defaultProps = {
  noPadding: false,
  children: null,
};

const propTypes = {
  noPadding: PropTypes.bool,
  children: PropTypes.node,
};

const ModalBody = ({
  noPadding,
  children,
}) => (
  <Flex
    direction="col"
    className={classnames(
      !noPadding && 'p-10',
      'flex-1 overflow-y-auto',
    )}
  >
    {children}
  </Flex>
);

ModalBody.defaultProps = defaultProps;
ModalBody.propTypes = propTypes;

export default ModalBody;
